var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2867 12H10.2867V10H14.2867V12ZM14.2867 15H8.28674V17H14.2867V15ZM18.2867 21V2H13.1157C12.7027 0.836 11.5907 0 10.2867 0H8.28674C6.98274 0 5.87074 0.836 5.45774 2H0.286743V21C0.286743 22.654 1.63274 24 3.28674 24H15.2867C16.9407 24 18.2867 22.654 18.2867 21ZM7.28674 4V3C7.28674 2.449 7.73574 2 8.28674 2H10.2867C10.8377 2 11.2867 2.449 11.2867 3V4H16.2867V21C16.2867 21.551 15.8377 22 15.2867 22H3.28674C2.73574 22 2.28674 21.551 2.28674 21V4H7.28674ZM6.28674 15H4.28674V17H6.28674V15ZM7.12474 11.519L9.88374 8.817L8.48474 7.388L5.95174 9.868L4.71074 8.676L3.32474 10.118L4.77474 11.511C5.10074 11.837 5.52874 11.999 5.95574 11.999C6.38074 11.999 6.80374 11.838 7.12374 11.518L7.12474 11.519Z",
    fill: "#BABABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.ace616cf42901cd506e0d1d0d31dd799.svg";
export { ForwardRef as ReactComponent };